"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.atanDocs = void 0;
var atanDocs = exports.atanDocs = {
  name: 'atan',
  category: 'Trigonometry',
  syntax: ['atan(x)'],
  description: 'Compute the inverse tangent of a value in radians.',
  examples: ['atan(0.5)', 'atan(tan(0.5))'],
  seealso: ['tan', 'acos', 'asin']
};